






























































































































































































































import { Component, Prop } from 'vue-property-decorator';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import FormError from '@/components/common/forms/FormError.vue';
import { GoalModel, GoalValueType, IGoal, IUser } from 'admiral-core';
import FormTextarea from '@/components/common/forms/FormTextarea.vue';
import { CheckIcon, CopyIcon, PlusIcon } from 'vue-feather-icons';
import FormDateInput from '@/components/common/forms/FormDateInput.vue';
import AgencyStatusSelect from '@/components/common/selects/AgencyStatusSelect.vue';
import AdmiralCheckbox from '@/components/common/selects/AdmiralCheckbox.vue';
import ProductSelect from '@/components/common/selects/ProductSelect.vue';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import dayjs from 'dayjs';

@Component({
  computed: {
    GoalValueType() {
      return GoalValueType;
    },
  },
  components: {
    UserSelect,
    ProductSelect,
    AdmiralCheckbox,
    AgencyStatusSelect,
    FormDateInput,
    FormTextarea,
    FormError,
    FormInput,
    FormRow,
    PlusIcon,
    CopyIcon,
    CheckIcon,
  },
})
export default class GoalForm extends mixins(BaseMixin) {
  @Prop({ required: true, type: Object })
  readonly value!: GoalModel;

  @Prop({ required: true, type: Object })
  readonly errors!: GoalModel;

  @Prop({ required: false, type: String, default: 'agency' })
  readonly type!: IGoal['type'];

  @Prop({ required: false, type: Array, default: [] })
  readonly usersOptions!: IUser[];

  async mounted() {
    //
  }

  onInput(key: string, value: any) {
    this.$emit('input', { ...this.value, [key]: value });
  }

  onErrorReset(key: string) {
    this.$emit('reset-error', key);
  }

  updateValueType(valueType: GoalValueType) {
    this.onInput('valueType', valueType);
  }

  async selectAllProducts() {
    await this.$store.dispatch('DataModule/fetchProducts', {
      agency: this.user.agency,
    });
    this.onInput('products', this.products);
  }

  clearAllProducts() {
    this.onInput('products', []);
  }

  updateType(type: IGoal['type']) {
    this.onInput('type', type);
  }

  updatePolicyType(policyType: IGoal['policyType']) {
    let type = policyType;

    // you so ugly
    if (this.value.policyType === 'all') {
      if (policyType === 'new') {
        type = 'substitute';
      } else {
        type = 'new';
      }
    } else {
      if (policyType === 'new' && this.value.policyType === 'substitute') {
        type = 'all';
      } else if (policyType === 'new' && this.value.policyType === 'new') {
        type = 'none';
      } else if (policyType === 'substitute' && this.value.policyType === 'new') {
        type = 'all';
      } else if (policyType === 'substitute' && this.value.policyType === 'substitute') {
        type = 'none';
      }
    }

    this.onInput('policyType', type);
  }

  get isBusinessYear() {
    // check if from and to are exactly one year apart
    if (!this.value.from || !this.value.to) return false;

    const from = dayjs(this.value.from).startOf('day');
    let to = dayjs(this.value.to).startOf('day');

    // if to is last day of year, set to to first day of next year
    if (to.isSame(dayjs().endOf('year'), 'day')) {
      to = to.set('year', to.year() + 1).startOf('year');
    }

    // Check if dates are exactly one year apart
    return to.diff(from, 'year', true) === 1;
  }

  get businessYear() {
    return this.value.from ? dayjs(this.value.from).format('YYYY') : '';
  }
}
